import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import { ForwardMessagePopup } from 'APP/main/PopupManager/Popups/ForwardMessagePopup/ForwardMessagePopup';
import { Features } from 'APP/packages/features/Features';
import { RouterPage } from 'APP/router/constants';
import { useNavigateTo } from 'APP/router/hooks/useNavigateTo';

export default ({ message }) => {
  const navigateTo = useNavigateTo();

  const source = useAsObservableSource({
    message,
    navigateTo,
  });

  const presenter = useLocalStore(() => ({
    childPopup: null,

    forward: () => {
      presenter.childPopup = Tasks.app.openPopup(ForwardMessagePopup, {
        params: { groupId: presenter.message.groupId, messageIds: [presenter.message.id] },
      });
    },

    edit: () => {
      navigateTo({
        to: `/${RouterPage.Channels}/${presenter.message.groupId}/article/${presenter.message.id}`,
      });
    },

    get message() {
      return source.message;
    },

    get isShowDeleteAction() {
      return presenter.message && presenter.message.group.withMeInAdmins;
    },

    get isShowEditAction() {
      return (presenter.message?.canBeEdit && Features.isArticleEnabled()) || false;
    },

    get isShowForwardAction() {
      return presenter.message && !presenter.message.isScheduled;
    },
  }));

  useEffect(() => {
    return () => presenter.childPopup?.close();
  }, []);

  return presenter;
};
